import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const limitedCompany: AppContent['limitedCompany'] = {
  metaContent: MetaContentValues.limitedCompany,

  pageHeading: 'Limited company mortgages explained',

  section1Heading: 'What is a limited company?',

  section1Text1:
    'A limited company is a business structure that exists as a separate legal entity from its owners. In the UK, it must be registered with Companies House and is its own legal entity.',

  section1Text2:
    'When it comes to renting out properties, this means the company:',

  section1pargraphList: [
    'owns the property, not you',
    'receives the rental income',
    'pays corporation tax on the profits.',
  ],

  section2Heading: 'Our limited company mortgages',

  section2Text1:
    'Our limited company mortgages are available to newly formed limited companies, experienced landlords and portfolio landlords, who are looking to purchase or remortgage.',

  section2Text2: 'These mortgages are available through a broker.',
  section3Heading: 'Our limited company criteria',
  section3Text1: 'To be eligible, the limited company must meet the following:',
  section3BoldList1: [
    {
      key: 'Ownership',
      value:
        'Up to four individuals can be listed as active parties, with 100% ownership shared between them.',
    },
    {
      key: 'Location',
      value: 'Registered with Companies House in England, Wales or Scotland.',
    },
    {
      key: 'Purpose',
      value:
        'Set up as a special purpose vehicle (SPV) solely to hold and manage property investments. Trading companies are not eligible.',
    },
    {
      key: 'SIC codes',
      value:
        'The company must be registered under one or more of the following Standard Industrial Classification (SIC) codes:',
    },
  ],

  section3PargraphList1: [
    '- 68209 - Other letting of own property',

    '- 68100 - Buying and selling of own real estate',

    '- 68320 - Management of real estate on a fee or contract basis',

    '- 68201 - Renting and operating of Housing Association real estate',
  ],
  section3BoldList2: [
    {
      key: 'Loan to value (LTV)',
      value:
        'A maximum of 75% LTV on both the subject property and the overall portfolio.',
    },
    {
      key: 'Rental coverage',
      value:
        'The total rental income across the portfolio must meet our stress-tested rental coverage of:',
    },
  ],
  section3PargraphList2: [
    '- 125% for standard landlords',
    '- 145% for portfolio landlords (owning 4 or more mortgaged BTL properties)',
  ],
  section3BoldList3: [
    {
      key: 'Guarantee',
      value:
        'Personal guarantees are required from all directors, shareholders with >25% shareholding and any People with Significant Control, up to a maximum of 4 individuals. Any companies with more than 4 of these individuals will not be accepted.',
    },
    {
      key: 'Business Account',
      value:
        'A Business Bank account must be set up before applying for a Limited Company mortgage.',
    },
  ],
  section4Heading: 'Ready to apply?',
  section4Text1:
    'Our limited company mortgages are only available through mortgage brokers. Speak to your broker about applying.',
  section4Text2:
    "They'll need details about the property you're letting and your existing portfolio, including:",
  section4pargraphList: [
    'property addresses',
    'year of construction',
    'purchase dates and prices',
    'gross monthly rental income',
    'estimated property valuations',
    'leasehold status',
    'whether the properties are managed by an agent.',
  ],
};

export default limitedCompany;
